<template>
	<!-- Page Introduction Wrapper -->
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Account</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a>Seller Register</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- Page Introduction Wrapper /- -->
	<!-- Account-Page -->
	<div>
		<div class="container-fluid">
			<div class="row justify-content-center">
				<div
					class="col-11 col-sm-10 col-md-10 col-lg-8 col-xl-5 text-center p-0 mt-3 mb-2"
				>
					<div class="card px-0 pt-4 pb-0 mt-3 mb-3">
						<h2 id="heading"><b>Sign Up Your Seller Account</b></h2>
						<p>Fill all form field to go to next step</p>
						<form id="msform">
							<!-- progressbar -->
							<ul id="progressbar">
								<li :class="{active: currentStep > 0}" id="account">
									<strong> Account</strong>
								</li>
								<li :class="{active: currentStep > 1}" id="verification">
									<strong>Verification</strong>
								</li>
								<li :class="{active: currentStep > 2}" id="payment">
									<strong>Business</strong>
								</li>
								<li :class="{active: currentStep > 3}" id="warehouse">
									<strong>Warehouse</strong>
								</li>
							</ul>
							<div class="progress">
								<div
									class="progress-bar progress-bar-striped progress-bar-animated"
									role="progressbar"
									:style="{width: currentStep * 25 + '%'}"
									aria-valuemin="0"
									aria-valuemax="100"
								></div>
							</div>
							<br />
							<!-- fieldsets -->
							<fieldset :class="{fieldset_active: currentStep == 1}">
								<form action="" @submit.prevent="nextStep">
									<!-- STEP-1 -->
									<div class="form-card">
										<div class="">
											<label class="fieldlabels"
												>Email: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="email"
												name="email"
												v-model="form.email"
												placeholder="Email Address"
												autocomplete="off"
												required
											/>
											<div class="invalid-feedback">Please choose a username.</div>
										</div>
										<div>
											<label class="fieldlabels"
												>Phone Number: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="email"
												v-model="form.phone_number"
												placeholder="Phone Number"
												autocomplete="off"
												pattern="[0-9]*"
												title="Only Numbers Allowed"
												minlength="10"
												maxlength="10"
												required
											/>
											<div class="invalid-feedback">Please choose a username.</div>
										</div>
										<div class="u-s-m-b-30">
											<input
												type="checkbox"
												class="check-box"
												id="accept"
												v-model="tc_accepted"
												value="1"
											/>
											<label class="label-text no-color" for="accept"
												>I’ve read and accept the
												<router-link
													:to="{name: 'TermsAndConditions', query: {type: 'seller'}}"
													class="u-c-brand"
													>terms & conditions</router-link
												>
											</label>
										</div>
									</div>
									<button class="next action-button" type="submit">Next</button>
								</form>
							</fieldset>
							<!-- STEP-2 -->
							<fieldset :class="{fieldset_active: currentStep == 2}">
								<form action="" @submit.prevent="nextStep">
									<div class="form-card">
										<div class="">
											<label class="fieldlabels"
												>Verify OTP: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												pattern="[0-9]*"
												title="Only Numbers Allowed"
												name="email_otp"
												placeholder="Email OTP"
												v-model="form.email_otp"
												autocomplete="off"
												required
											/>
											<small
												class="font-weight-bold text-success resend_otp"
												v-if="resend_otp_timer.email != 0"
											>
												Resend OTP in {{ millisToMinutesAndSeconds(resend_otp_timer.email) }}</small
											>
											<small
												class="font-weight-bold text-success resend_otp"
												@click="resendOtp('email')"
												v-else
												>Click here to resend</small
											>
											<div class="invalid-feedback">
												Invalid OTP&nbsp;&nbsp;<span class="text-success font-weight-normal"
													>Click here to resend</span
												>
											</div>
										</div>
										<div class="">
											<label class="fieldlabels"
												>Verify OTP: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="phone_otp"
												pattern="[0-9]*"
												title="Only Numbers Allowed"
												placeholder="Phone OTP"
												autocomplete="off"
												v-model="form.phone_otp"
												required
											/>
											<small
												class="font-weight-bold text-success resend_otp"
												v-if="resend_otp_timer.phone != 0"
											>
												Resend OTP in {{ millisToMinutesAndSeconds(resend_otp_timer.phone) }}</small
											>
											<small
												class="font-weight-bold text-success resend_otp"
												@click="resendOtp('phone')"
												v-else
												>Click here to resend</small
											>
											<div class="invalid-feedback">Invalid OTP.</div>
										</div>
										<div>
											<label class="fieldlabels"
												>Password: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="password"
												name="pwd"
												placeholder="Password"
												autocomplete="off"
												v-model="form.password"
												minlength="8"
												required
											/>
											<div class="invalid-feedback">Please choose a username.</div>
										</div>
										<div>
											<label class="fieldlabels"
												>Confirm Password: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="password"
												name="cpwd"
												placeholder="Confirm Password"
												autocomplete="off"
												v-model="form.confirm_password"
												minlength="8"
												required
											/>
											<div class="invalid-feedback">Please choose a username.</div>
										</div>
									</div>
									<button class="next action-button" type="submit">Next</button>
								</form>
							</fieldset>
							<!-- STEP-3 -->
							<fieldset :class="{fieldset_active: currentStep == 3}">
								<form action="" @submit.prevent="nextStep">
									<div class="form-card">
										<div>
											<label class="fieldlabels"
												>Business Name: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="business_name"
												placeholder="Business Name"
												v-model="form.business_name"
												required
												autocomplete="off"
											/>
											<div class="invalid-feedback">invalid otp.</div>
										</div>
										<div>
											<label class="fieldlabels"
												>Address 1: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="address1"
												placeholder="Address 1"
												v-model="form.address_1"
												required
												autocomplete="off"
											/>
											<div class="invalid-feedback">invalid otp.</div>
										</div>
										<div>
											<label class="fieldlabels"
												>Address 2: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="address2"
												placeholder="Address 2"
												v-model="form.address_2"
												required
												autocomplete="off"
											/>
											<div class="invalid-feedback">invalid otp.</div>
										</div>
										<div>
											<label for="state">State</label>
											<select class="form-control" id="state" v-model="form.state">
												<option value="AN">Andaman and Nicobar Islands</option>
												<option value="AP">Andhra Pradesh</option>
												<option value="AR">Arunachal Pradesh</option>
												<option value="AS">Assam</option>
												<option value="BR">Bihar</option>
												<option value="CH">Chandigarh</option>
												<option value="CT">Chhattisgarh</option>
												<option value="DN">Dadra and Nagar Haveli</option>
												<option value="DD">Daman and Diu</option>
												<option value="DL">Delhi</option>
												<option value="GA">Goa</option>
												<option value="GJ">Gujarat</option>
												<option value="HR">Haryana</option>
												<option value="HP">Himachal Pradesh</option>
												<option value="JK">Jammu and Kashmir</option>
												<option value="JH">Jharkhand</option>
												<option value="KA">Karnataka</option>
												<option value="KL">Kerala</option>
												<option value="LA">Ladakh</option>
												<option value="LD">Lakshadweep</option>
												<option value="MP">Madhya Pradesh</option>
												<option value="MH">Maharashtra</option>
												<option value="MN">Manipur</option>
												<option value="ML">Meghalaya</option>
												<option value="MZ">Mizoram</option>
												<option value="NL">Nagaland</option>
												<option value="OR">Odisha</option>
												<option value="PY">Puducherry</option>
												<option value="PB">Punjab</option>
												<option value="RJ">Rajasthan</option>
												<option value="SK">Sikkim</option>
												<option value="TN">Tamil Nadu</option>
												<option value="TG">Telangana</option>
												<option value="TR">Tripura</option>
												<option value="UP">Uttar Pradesh</option>
												<option value="UT">Uttarakhand</option>
												<option value="WB">West Bengal</option>
											</select>
										</div>
										<div class="">
											<label class="fieldlabels"
												>City: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="city"
												placeholder="City"
												v-model="form.city"
												required
												autocomplete="off"
											/>
											<div class="invalid-feedback">invalid otp.</div>
										</div>
										<div class="">
											<label class="fieldlabels"
												>Pincode: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="pincode"
												placeholder="Pincode"
												v-model="form.pincode"
												pattern="[0-9]*"
												title="Only Numbers Allowed"
												minlength="6"
												maxlength="6"
												required
												autocomplete="off"
											/>
										</div>
										<div class="">
											<label class="fieldlabels"
												>Pan Number: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="pan_number"
												placeholder="Pan Number"
												v-model="form.pan_number"
												required
												autocomplete="off"
											/>
										</div>
										<div class="">
											<label class="fieldlabels"
												>Tax no: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="tax_no"
												placeholder="Tax no"
												v-model="form.tax_no"
												required
												autocomplete="off"
											/>
											<div class="invalid-feedback">invalid otp.</div>
										</div>
									</div>
									<button class="next action-button" type="submit">Next</button>
								</form>
							</fieldset>
							<!-- STEP-4 -->
							<fieldset :class="{fieldset_active: currentStep == 4}">
								<form action="" @submit.prevent="nextStep">
									<div class="form-card">
										<div>
											<label class="fieldlabels"
												>Warehouse Name: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="warehouse_name"
												placeholder="Warehouse Name"
												v-model="form.warehouse_name"
												required
												autocomplete="off"
											/>
										</div>

										<div class="mb-1">
											<label class="fieldlabels"
												>Address: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												readonly
												type="text"
												name="warehouse_name"
												placeholder="Address"
												v-model="form.warehouse_address"
											/>
											<button
												class="select_address_button"
												type="button"
												data-toggle="modal"
												data-target="#seller_register"
											>
												Select Address
											</button>
										</div>
										<div>
											<label class="fieldlabels"
												>Latitude: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												readonly
												type="text"
												name="warehouse_name"
												placeholder="Latitude"
												v-model="form.latitude"
											/>
										</div>

										<div class="">
											<label class="fieldlabels"
												>longitude: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												readonly
												type="text"
												name="warehouse_name"
												placeholder="longitude"
												v-model="form.longitude"
											/>
											<div class="invalid-feedback"></div>
										</div>

										<div>
											<label for="state">State</label>
											<select
												class="form-control"
												id="warehouse_state"
												v-model="form.warehouse_state"
											>
												<option value="AN">Andaman and Nicobar Islands</option>
												<option value="AP">Andhra Pradesh</option>
												<option value="AR">Arunachal Pradesh</option>
												<option value="AS">Assam</option>
												<option value="BR">Bihar</option>
												<option value="CH">Chandigarh</option>
												<option value="CT">Chhattisgarh</option>
												<option value="DN">Dadra and Nagar Haveli</option>
												<option value="DD">Daman and Diu</option>
												<option value="DL">Delhi</option>
												<option value="GA">Goa</option>
												<option value="GJ">Gujarat</option>
												<option value="HR">Haryana</option>
												<option value="HP">Himachal Pradesh</option>
												<option value="JK">Jammu and Kashmir</option>
												<option value="JH">Jharkhand</option>
												<option value="KA">Karnataka</option>
												<option value="KL">Kerala</option>
												<option value="LA">Ladakh</option>
												<option value="LD">Lakshadweep</option>
												<option value="MP">Madhya Pradesh</option>
												<option value="MH">Maharashtra</option>
												<option value="MN">Manipur</option>
												<option value="ML">Meghalaya</option>
												<option value="MZ">Mizoram</option>
												<option value="NL">Nagaland</option>
												<option value="OR">Odisha</option>
												<option value="PY">Puducherry</option>
												<option value="PB">Punjab</option>
												<option value="RJ">Rajasthan</option>
												<option value="SK">Sikkim</option>
												<option value="TN">Tamil Nadu</option>
												<option value="TG">Telangana</option>
												<option value="TR">Tripura</option>
												<option value="UP">Uttar Pradesh</option>
												<option value="UT">Uttarakhand</option>
												<option value="WB">West Bengal</option>
											</select>
										</div>
										<div>
											<label class="fieldlabels"
												>Pincode: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="warehouse_pincode"
												placeholder="Pincode"
												v-model="form.warehouse_pincode"
												pattern="[0-9]*"
												title="Only Numbers Allowed"
												minlength="6"
												maxlength="6"
												required
												autocomplete="off"
											/>
										</div>
									</div>
									<button class="next action-button" type="submit">Next</button>
								</form>
							</fieldset>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Account-Page /- -->
	<LocationModal modal_id="seller_register" @change="handleLocationSelect" />
	<Footer />
	<vue-element-loading
		:active="loading"
		spinner="spinner"
		:is-full-screen="true"
		color="#343a40"
		text="Please Wait..."
	/>
</template>

<script>
	import axios from "axios";
	import Footer from "../components/Bottom/Footer.vue";
	import LocationModal from "../components/Modals/LocationModal";
	import {useToast} from "vue-toastification";
	export default {
		components: {Footer, LocationModal},
		data() {
			return {
				currentStep: 1, // Current step of the wizard
				form: {
					email: "",
					phone_number: "",
					phone_otp: "",
					email_otp: "",
					password: "",
					confirm_password: "",
					business_name: "",
					address_1: "",
					address_2: "",
					state: "AN",
					city: "",
					pincode: "",
					pan_number: "",
					tax_no: "",
					warehouse_name: "",
					warehouse_address: "",
					latitude: "",
					longitude: "",
					warehouse_state: "AN",
					warehouse_pincode: "",
				},
				loading: false,
				error: null,
				resend_otp_timer: {phone: null, email: null}, // Timer for resending OTP
				resend_otp_timer_interval: {phone: null, email: null}, // Interval for resending OTP
				resend_otp_timer_duration: 30000, // Duration for resending OTP
				user_id: null,
				tc_accepted: false,
			};
		},
		methods: {
			async nextStep() {
				if (this.currentStep > 4) return;
				if (!this.tc_accepted) {
					useToast().error("Please accept terms and conditions", {timeout: 3000});
					return;
				}
				this.loading = true;
				let postData = this.genPostData();
				try {
					let {data} = await this.saveDataToDB(postData);
					console.log(data.payload);
					if (this.currentStep == 1 && data.payload.id) {
						this.user_id = data.payload.id;
					}
					this.loading = false;
					let step_status = parseInt(data.payload.step_status); //getting step status from response
					if (this.currentStep == 4 && step_status == 4) {
						//if step status is 4 and current step is 4 that means user completed all steps
						useToast().success("Your account has been created successfully.", {
							duration: 3000,
						});
						window.location.reload();
						return;
					}
					if (this.currentStep == 1 && step_status == 4) {
						//if step status is 4 and current step is 1 that means user already registered
						useToast().error("An account is already registered, Please login", {
							duration: 3000,
						});
						return;
					}
					if (step_status > 1) {
						// resume seller registration
						this.currentStep = step_status + 1;
					} else {
						this.currentStep++;
					}
				} catch (error) {
					this.loading = false;
					this.error = error.response.data.message;
					useToast().error(this.error, {timeout: 3000});
				}
			},
			previousStep() {
				if (this.currentStep > 1) {
					// If the current step is greater than 1, then go to the previous step
					this.currentStep--;
				}
			},
			handleLocationSelect(event) {
				console.log(event);
				if (!event) return;
				this.form.warehouse_address = event.address;
				this.form.latitude = event.lat;
				this.form.longitude = event.lng;
			},

			async saveDataToDB(postData = null) {
				return new Promise((resolve, reject) => {
					axios
						.post(process.env.VUE_APP_API_URL + "/api/seller-signup", postData)
						.then((response) => {
							resolve(response);
						})
						.catch((error) => {
							reject(error);
						});
				});
			},

			millisToMinutesAndSeconds(millis) {
				var minutes = Math.floor(millis / 60000);
				var seconds = ((millis % 60000) / 1000).toFixed(0);
				return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
			},

			resendOtp(type) {
				// Resend OTP where type is phone or email
				this.resend_otp_timer[type] = this.resend_otp_timer_duration;
				this.startTimer(type);
			},
			startTimer(type) {
				// Start timer for resending OTP
				this.resend_otp_timer_interval[type] = setInterval(() => {
					this.resend_otp_timer[type] -= 1000;
					if (this.resend_otp_timer[type] <= 0) {
						clearInterval(this.resend_otp_timer_interval[type]);
					}
				}, 1000);
			},

			genPostData() {
				let postData = {};
				switch (this.currentStep) {
					//case 1 account info, case 2 verification, case 3 business info, case 4 warehouse info
					case 1:
						postData = {
							step_number: this.currentStep,
							email: this.form.email,
							phone_number: this.form.phone_number,
						};
						break;
					case 2:
						postData = {
							step_number: this.currentStep,
							signup_id: this.user_id,
							email_otp: this.form.email_otp,
							phone_otp: this.form.phone_otp,
							password: this.form.password,
							password_confirmation: this.form.confirm_password,
						};
						break;
					case 3:
						postData = {
							step_number: this.currentStep,
							signup_id: this.user_id,
							business_name: this.form.business_name,
							address1: this.form.address_1,
							address2: this.form.address_2,
							business_state: this.form.state,
							city: this.form.city,
							business_pin_code: this.form.pincode,
							pan_no: this.form.pan_number,
							tax_no: this.form.tax_no,
						};
						break;
					case 4:
						postData = {
							step_number: this.currentStep,
							signup_id: this.user_id,
							warehouse_name: this.form.warehouse_name,
							address: this.form.warehouse_address,
							warehouse_state: this.form.warehouse_state,
							warehouse_pin_code: this.form.warehouse_pincode,
							latitude: this.form.latitude,
							longitude: this.form.longitude,
						};
						break;
					default:
						break;
				}
				return postData;
			},
		},
		mounted() {},
		watch: {
			currentStep(step) {
				if (step == 2) {
					// If the current step is 2, then start the timer for resending OTP
					clearInterval(this.resend_otp_timer_interval["phone"]);
					clearInterval(this.resend_otp_timer_interval["email"]);
					this.resend_otp_timer.phone = this.resend_otp_timer_duration;
					this.resend_otp_timer.email = this.resend_otp_timer_duration;
					this.startTimer("phone");
					this.startTimer("email");
				}
			},
		},
	};
</script>

<style scoped>
	#heading {
		text-transform: uppercase;
		color: #343a40;
		font-weight: normal;
	}

	#msform {
		text-align: center;
		position: relative;
		margin-top: 20px;
	}

	#msform fieldset {
		background: white;
		border: 0 none;
		border-radius: 0.5rem;
		box-sizing: border-box;
		width: 100%;
		margin: 0;
		padding-bottom: 20px;
		position: relative;
	}

	.form-card {
		text-align: left;
	}
	fieldset {
		display: none;
	}
	.fieldset_active {
		display: block !important;
	}

	#msform input,
	#msform textarea,
	#msform select {
		padding: 8px 15px 8px 15px;
		border: 1px solid #ccc;
		border-radius: 0px;
		margin-top: 2px;
		width: 100%;
	}

	#msform input:focus,
	#msform textarea:focus {
		-moz-box-shadow: none !important;
		-webkit-box-shadow: none !important;
		box-shadow: none !important;
		border: 1px solid #343a40;
		outline-width: 0;
	}

	#msform .action-button {
		width: 100px;
		background: #343a40;
		font-weight: bold;
		color: white;
		border: 0 none;
		border-radius: 5px;
		cursor: pointer;
		padding: 10px 5px;
		margin: 10px 0px 10px 5px;
		float: right;
	}

	#msform .action-button:hover,
	#msform .action-button:focus {
		background-color: #000000;
	}

	#msform .action-button-previous {
		width: 100px;
		background: #616161;
		font-weight: bold;
		color: white;
		border: 0 none;
		border-radius: 5px;
		cursor: pointer;
		padding: 10px 5px;
		margin: 10px 5px 10px 0px;
		float: right;
	}

	#msform .action-button-previous:hover,
	#msform .action-button-previous:focus {
		background-color: #000000;
	}

	.card {
		z-index: 0;
		border: none;
		position: relative;
	}

	.fs-title {
		font-size: 25px;
		color: #343a40;
		margin-bottom: 15px;
		font-weight: normal;
		text-align: left;
	}

	.steps {
		font-size: 25px;
		color: gray;
		margin-bottom: 10px;
		font-weight: normal;
		text-align: right;
	}

	.fieldlabels {
		color: gray;
		text-align: left;
	}

	#progressbar {
		margin-bottom: 30px;
		overflow: hidden;
		color: lightgrey;
		padding-left: 0px;
	}

	#progressbar .active {
		color: #343a40;
	}

	#progressbar li {
		list-style-type: none;
		font-size: 15px;
		width: 25%;
		float: left;
		position: relative;
		font-weight: 400;
	}

	#progressbar #account:before {
		font-family: "Font Awesome 5 Free";
		content: "\f007";
		font-weight: 900;
	}

	#progressbar #verification:before {
		font-family: "Font Awesome 5 Free";
		content: "\f017";
		font-weight: 900;
	}

	#progressbar #payment:before {
		font-family: "Font Awesome 5 Free";
		content: "\f01c";
		font-weight: 900;
	}

	#progressbar #warehouse:before {
		font-family: "Font Awesome 5 Free";
		content: "\f015";
		font-weight: 900;
	}

	#progressbar li:before {
		width: 50px;
		height: 50px;
		line-height: 45px;
		display: block;
		font-size: 20px;
		color: #ffffff;
		background: lightgray;
		border-radius: 50%;
		margin: 0 auto 10px auto;
		padding: 2px;
	}

	#progressbar li:after {
		content: "";
		width: 100%;
		height: 2px;
		background: lightgray;
		position: absolute;
		left: 0;
		top: 25px;
		z-index: -1;
	}

	#progressbar li.active:before,
	#progressbar li.active:after {
		background: #343a40;
	}

	.progress {
		height: 20px;
	}

	.progress-bar {
		background-color: #343a40;
	}

	.fit-image {
		width: 100%;
		object-fit: cover;
	}
	.select_address_button {
		width: 10rem;
		background: #343a40;
		font-weight: bold;
		color: white;
		border: 0 none;
		border-radius: 5px;
		cursor: pointer;
		padding: 10px 5px;
		margin: 10px 0px 10px 5px;
	}
	.form-card div {
		margin-bottom: 20px;
	}
	.is-invalid {
		margin-bottom: -10px !important;
	}
	.is-invalid .invalid-feedback {
		display: block;
		font-weight: bold;
	}
	.is-invalid input {
		border: 1px solid red !important;
	}
	.resend_otp {
		cursor: pointer;
	}
</style>
